import api from "../../utils/Api";
import {
  DELETE_USER_REQUEST,
  DELETE_USER_SUCCESS,
  DELETE_USER_ERROR,
} from "./DeleteUserTypes";

export const deleteUserRequest = () => {
  return {
    type: DELETE_USER_REQUEST,
  };
};

export const deleteUserSuccess = (notes) => {
  return {
    type: DELETE_USER_SUCCESS,
    payload: notes,
  };
};

export const deleteUserFailure = (error) => {
  return {
    type: DELETE_USER_ERROR,
    payload: error,
  };
};

export const deleteUser = (userId) => {
  return async (dispatch) => {
    dispatch(deleteUserRequest());
    try {
        const response = await api.delete("user/delete/",  {
            headers: {
              Authorization:
                "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
            },
            data: {
                user_id: userId
            },
          });
      const deleteUserData = response.data;
     // console.log("deleteUserData", deleteUserData)
      dispatch(deleteUserSuccess(deleteUserData));
    } catch (error) {
      console.log("Redux error - ", error.response.data.message);
      const errorMsg = error.response.data.message;
      dispatch(deleteUserFailure(errorMsg));
    }
  };
};
